module.exports = __webpack_public_path__ + "media/images/athletes/3551-b279e33340571b89638de3ccc67a5aba.png";